var dateWithoutDay;

Date.prototype.toUTC = function() {
	return new Date(Date.UTC(this.getFullYear(), this.getMonth(), this.getDate(), 0, 0, 0, 0));
};


Date.prototype.addDays = function(days) {
	var dat;
	dat = new Date(this.valueOf()).toUTC();
	dat.setUTCDate(dat.getUTCDate() + days);
	return dat;
};

dateWithoutDay = function(dateString) {
	return dateString.slice(0, 7);
};


function initDatePicker() {
	function dateShortString(date) {
		if ($.fn.datepicker.DPGlobal) {
			return $.fn.datepicker.DPGlobal.formatDate(date, 'yymmdd', 'en');
		}
	}

	function createUTC(date) {
		var x = new Date(date);
		x.setTime(x.getTime() + x.getTimezoneOffset() * 60000);
		return x;
	}

	function formatCurrency(x) {
		return selectedCurrencyFormat.replace("{amount}", x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
	}

	var $listingDatePicker, availabilities, highlightDuration, highlightDurationForActive, unhighlightDuration;
	$listingDatePicker = $('#listing_query_arrival_date.date-picker');

	var availabilities = {
		dates: null,
		guaranteed: null,
		duration: $listingDatePicker.data('duration-in-days')
	};

	// lp_variable_duration
	if ( $('#duration_in_days').length ) {
		$('#duration_in_days').change( function() {
			var packagesHeight = $('.listing-packages').height();
			if(packagesHeight == 0){
				$('.package__filtersError').removeClass('hide');
			}else{
				$('.package__filtersError').addClass('hide');
			};
			availabilities.duration = $(this).val();
			$listingDatePicker.datepicker();
			unhighlightDuration();
			highlightDuration('#listing-availability-container .datepicker .day.active');
		});
	}

	var packageAvailabilities = {};
	var selectedPackageId = null;

	var $availability = $("#listing-availability-container");

	if ($availability.length) {
		var availability = decompressAvailability($availability.data('availability'));
		for (var index in availability) {
			var date = availability[index];
			var datestr = dateShortString(createUTC(date.date));
			if (!availabilities.dates)
				availabilities.dates = {};

			availabilities.dates[datestr] = true;
			if (date.type > 0 && date.slots > 0) {
				if (!availabilities.guaranteed)
					availabilities.guaranteed = {};
				availabilities.guaranteed[datestr] = true;
			}
		}

		$("input.package-selection-item[data-availability]").each(function() {
			var $this = $(this);
			var id = parseInt($this.data("id"));
			var dates = {};

			var availability = decompressAvailability($this.data("availability"));
			for (var index in availability) {
				var date = availability[index];
				var datestr = dateShortString(createUTC(date.date));
				dates[datestr] = date;
			}
			packageAvailabilities[id] = dates;
		});

		var $checkedPkg = $("input.package-selection-item[data-availability]:checked");
		if ($checkedPkg.length) {
			selectedPackageId = parseInt($checkedPkg.data("id"));
		}
	}

	// Pre-convert cross-currency discount amounts once on load so date selections are instant.
	var discountAmtConversionCache = {}; // key: "pkgAmt|pkgCurrency" -> converted cents in selectedCurrency

	(function preConvertDiscountAmounts() {
		if (typeof currency === 'undefined' || !currency || !currency.convert) return;
		var seen = {};
		$("input.package-selection-item[data-availability]").each(function() {
			var pkgFormat   = $(this).attr('data-discount-format');
			var pkgAmt      = parseInt($(this).attr('data-discount-amount')) || 0;
			var pkgCurrency = ($(this).attr('data-discount-amount-currency') || '').toUpperCase();
			if (pkgFormat === 'amount' && pkgAmt > 0 && pkgCurrency && pkgCurrency !== selectedCurrency.toUpperCase()) {
				var key = pkgAmt + '|' + pkgCurrency;
				if (!seen[key]) {
					seen[key] = true;
			currency.convert(pkgAmt * 100, pkgCurrency, selectedCurrency.toUpperCase())
					.then(function(response) {
						discountAmtConversionCache[key] = response.to.amount;
						var currentDate = $('#listing_query_arrival_date').val() || $('#arrival_date_select').val();
						if (currentDate) updatePackagesForDate(createUTC(currentDate));
					})
					.catch(function() {});
				}
			}
		});
	})();

	highlightDuration = function(el) {
		var $days, duration, elIndex, highlightedDays;
		if ($(el).length) {
			$days = $('.day');
			elIndex = $days.index($(el));
			duration = parseInt(availabilities.duration);
			highlightedDays = $.grep($days, function(_, index) {
				return (index < elIndex + duration) && (index >= elIndex);
			});
			return $(highlightedDays).addClass('highlight');
		}
	};
	highlightDurationForActive = function() {
		return highlightDuration('.public .datepicker:visible .day.active');
	};
	unhighlightDuration = function() {
		return $(".day.highlight").removeClass('highlight');
	};

	$('.arrival_date_select').change(function(){
		if (!dateChanged($(this).val())) {
			$('#departure_dates div').hide();
			var div_id = 'dd_' + $(this).val();
			$('#' + div_id).show();
		}
	});

	$('#arrival_date_select').change(function(){
		$('#departure_dates div').hide();
		var div_id = 'dd_' + $(this).val();
		$('#' + div_id).show();
	});

	function updatePackagesForDate(date) {
		// Sync badge visibility before reading it for price display.
		if (typeof updateDiscountBadges === 'function') {
			updateDiscountBadges(date);
		}

		window.availabilityDate = date.getTime() / 1000;
		var datestr = dateShortString(createUTC(date));
		var lowest;
		var lowestDiscount;
		var $lowest;
		var highest;
		var $highest;
		var recheck = false;

		$("input.package-selection-item[data-availability]").each(function() {
			var $this = $(this);
			var id = parseInt($this.data("id"));

			var $price = $("#listing-query-package-price-" + id);
			var av = packageAvailabilities[id][datestr];
			if (av) { // available
				$this.data("availability-type", av.type);
				$this.data("availability-slots", av.slots);
				$this.closest("li").show();
				$price.attr('data-price',av.price);
				$price.attr('data-price-discount',av.discountedPrice);
//				$price.attr('data-price-discount',formatCurrency(av.discountedPrice));

			if (!lowest || (av.price < lowest)) {
				lowest = av.price;
				var $pkgBadge = $this.closest('li').find('.package-discount-badge');
					var noBadgeDiscountActive = false;
				if ($pkgBadge.length === 0 && $this.attr('data-discount-format')) {
					var hdrExpDaysAttr = $this.attr('data-discount-expiration-days');
					noBadgeDiscountActive = !hdrExpDaysAttr ||
						(typeof isDiscountActivated === 'function' &&
						 isDiscountActivated(parseInt(hdrExpDaysAttr), date, $this.attr('data-discount-type')));
				}
				var pkgDiscountActive = ($pkgBadge.length > 0 && !$pkgBadge.hasClass('hide')) || noBadgeDiscountActive;
				if (pkgDiscountActive) {
					var hdrComputedDiscount = av.discountedPrice;
					if (!hdrComputedDiscount || hdrComputedDiscount === av.price) {
						var hdrFmt = $this.attr('data-discount-format');
						var hdrAmt = parseInt($this.attr('data-discount-amount')) || 0;
						var hdrPct = parseInt($this.attr('data-discount-percentage')) || 0;
						var hdrCur = ($this.attr('data-discount-amount-currency') || '').toUpperCase();
						if (hdrFmt === 'percentage' && hdrPct > 0) {
							hdrComputedDiscount = Math.round(av.price * (100 - hdrPct) / 100);
						} else if (hdrFmt === 'amount' && hdrAmt > 0 && (!hdrCur || hdrCur === selectedCurrency.toUpperCase())) {
							hdrComputedDiscount = Math.round(av.price - hdrAmt);
						}
					}
					lowestDiscount = hdrComputedDiscount || 0;
				} else {
					lowestDiscount = 0;
				}
				$lowest = $this;
			}
				if (!highest || (av.price > highest)) {
					highest = av.price;
					$highest = $this;
				}

				// simplified_deals
				var deals = $price.parent().parent().find('.package-selection-item');
				var dealPercent = deals.attr('data-deal-percent');
				var dealFixed = deals.attr('data-deal-fixed');
				if(dealPercent || dealFixed){
					var newPrice = Math.round(av.price * (1 - dealPercent / 100)  - dealFixed);
					$price.html('<span class="promoPrice oldPrice">'+formatCurrency(av.price)+'</span><span class="promoPrice newPrice">'+formatCurrency(newPrice)+'</span>');
					if (!lowest || (newPrice < lowest)) {
						lowest = newPrice;
						$lowest = $this;
					};
					if (!highest || (newPrice > highest)) {
						highest = newPrice;
						$highest = $this;
					};
				}
				// simplified_deals

		//discounts
		var $badge = $this.closest('li').find('.package-discount-badge');
		var hasPackageDiscount = $badge.length > 0 && !$badge.hasClass('hide');

		if (hasPackageDiscount) {
			let discount = av.discountedPrice;
			let asyncDiscountPending = false;

			if (!discount || discount == '0' || discount == av.price) {
				var pkgFormat   = $this.attr('data-discount-format');
				var pkgAmt      = parseInt($this.attr('data-discount-amount')) || 0;
				var pkgPct      = parseInt($this.attr('data-discount-percentage')) || 0;
				var pkgCurrency = ($this.attr('data-discount-amount-currency') || '').toUpperCase();

				if (pkgFormat === 'percentage' && pkgPct > 0) {
					discount = Math.round(av.price * (100 - pkgPct) / 100);
				} else if (pkgFormat === 'amount' && pkgAmt > 0) {
					if (!pkgCurrency || pkgCurrency === selectedCurrency.toUpperCase()) {
						discount = Math.round(av.price - pkgAmt);
				} else if (typeof currency !== 'undefined' && currency && currency.convert) {
					var cacheKey1 = pkgAmt + '|' + pkgCurrency;
					if (discountAmtConversionCache[cacheKey1] !== undefined) {
						discount = Math.round(av.price - discountAmtConversionCache[cacheKey1] / 100);
					} else {
						var $priceEl  = $price;
						var basePrice = av.price;
						asyncDiscountPending = true;
						currency.convert(pkgAmt * 100, pkgCurrency, selectedCurrency.toUpperCase())
							.then(function(response) {
								discountAmtConversionCache[cacheKey1] = response.to.amount;
								var discountedPrice = Math.round(basePrice - (response.to.amount / 100));
								if (discountedPrice > 0 && discountedPrice < basePrice) {
									$priceEl.html(`<div class="listing-old-price">${formatCurrency(basePrice)}</div> <div class="listing-discount-price">${formatCurrency(discountedPrice)}</div>`);
								}
							})
							.catch(function() {});
					}
				}
			}
		}

		if (asyncDiscountPending) {
			$price.text(formatCurrency(av.price));
		} else if (discount && discount != '0' && discount != av.price && discount > 0) {
			$price.html(`<div class="listing-old-price">${formatCurrency(av.price)}</div> <div class="listing-discount-price">${formatCurrency(discount)}</div>`);
		} else {
			$price.text(formatCurrency(av.price));
		}
	} else if (!$badge.length && $this.attr('data-discount-format')) {
			var discountExpDaysAttr = $this.attr('data-discount-expiration-days');
			var rollingWindowActive = !discountExpDaysAttr ||
				(typeof isDiscountActivated === 'function' &&
				 isDiscountActivated(parseInt(discountExpDaysAttr), date, $this.attr('data-discount-type')));
			if (rollingWindowActive) {
				let discount = (av.discountedPrice && av.discountedPrice > 0 && av.discountedPrice !== av.price) ? av.discountedPrice : 0;
				let asyncDiscountPending = false;
				if (!discount) {
					var pkgFormat   = $this.attr('data-discount-format');
					var pkgAmt      = parseInt($this.attr('data-discount-amount')) || 0;
					var pkgPct      = parseInt($this.attr('data-discount-percentage')) || 0;
					var pkgCurrency = ($this.attr('data-discount-amount-currency') || '').toUpperCase();
					if (pkgFormat === 'percentage' && pkgPct > 0) {
						discount = Math.round(av.price * (100 - pkgPct) / 100);
					} else if (pkgFormat === 'amount' && pkgAmt > 0) {
						if (!pkgCurrency || pkgCurrency === selectedCurrency.toUpperCase()) {
							discount = Math.round(av.price - pkgAmt);
					} else if (typeof currency !== 'undefined' && currency && currency.convert) {
						var cacheKey2 = pkgAmt + '|' + pkgCurrency;
						if (discountAmtConversionCache[cacheKey2] !== undefined) {
							discount = Math.round(av.price - discountAmtConversionCache[cacheKey2] / 100);
						} else {
							var $priceEl  = $price;
							var basePrice = av.price;
							asyncDiscountPending = true;
							currency.convert(pkgAmt * 100, pkgCurrency, selectedCurrency.toUpperCase())
								.then(function(response) {
									discountAmtConversionCache[cacheKey2] = response.to.amount;
									var discountedPrice = Math.round(basePrice - (response.to.amount / 100));
									if (discountedPrice > 0 && discountedPrice < basePrice) {
										$priceEl.html(`<div class="listing-old-price">${formatCurrency(basePrice)}</div> <div class="listing-discount-price">${formatCurrency(discountedPrice)}</div>`);
									}
								})
								.catch(function() {});
						}
					}
				}
			}
			if (asyncDiscountPending) {
				$price.text(formatCurrency(av.price));
			} else if (discount && discount > 0 && discount !== av.price) {
					$price.html(`<div class="listing-old-price">${formatCurrency(av.price)}</div> <div class="listing-discount-price">${formatCurrency(discount)}</div>`);
				} else {
					$price.text(formatCurrency(av.price));
				}
			} else {
				$price.text(formatCurrency(av.price));
			}
		} else {
			$price.text(formatCurrency(av.price));
		}
		//discounts

		$price.attr('data-original-html', $price.html());

			var isInstantBooking = !!(window.lpInstantDates && window.lpInstantDates[id] && window.lpInstantDates[id][datestr]);
			$this.closest("li").find('.js-instant-booking-tag').toggleClass('hide', !isInstantBooking);

			if (av.type == 1) { // guaranteed
				// experiment: instant_booking_flow_full
				if (document.body.classList.contains('instant-book-flow')) {
					$this.removeAttr("disabled");
					$this.closest("li").addClass("instant");
					// also add an 'instant' identifier to the input field
					// this we can use to toggle the listing-primary-cta-box
					$this.closest("li input").addClass("instant");
				}
			}
			else if (av.type == 2) { // sold out
				$this.removeAttr("disabled");
				$this.closest("li").removeClass("instant");
			} else { // simple / on request
				$this.removeAttr("disabled");
				$this.closest("li").removeClass("instant");
			}
			} else { // no availability

				$this.closest("li").hide().removeClass("instant");
				$price.text("--");

				if ($this.is(':checked'))
					recheck = true;
			}

		});

		if (recheck && $lowest)
			$lowest.prop('checked', true);

		let newPrice = 0;
		const newPriceElement = document.querySelector('[data-price-discount]');
		if(newPriceElement != null) {
			newPrice = newPriceElement.dataset.priceDiscount;
		}
		if(lowestDiscount != 0 && lowestDiscount != lowest) {
			document.querySelector(".listing-price-wrapper span.price").innerHTML = `<div class="listing-old-price">${formatCurrency(lowest)}</div><div class="listing-discount-price">${formatCurrency(lowestDiscount)}</div>`;
		}
		else {
			$(".listing-price-wrapper span.price").text(lowest ? formatCurrency(lowest) : "--");
		}

		if($('.safety_usps_wrapper').length > 0){
			if(highest > 5000){
				$('.safety_usps_wrapper').hide();
			};
		};
	}

	function packageChanged() {
		var $this = $(this);
		var newPackageId = parseInt($this.data("id"));
		if (newPackageId && newPackageId !== selectedPackageId) {
			selectedPackageId = newPackageId;
			var dp = $listingDatePicker.data('datepicker');
			if (dp) dp.fill();
		}
	}

	$("input.package-selection-item[data-availability]").on('change', packageChanged);

	var selectedDate = $('#listing_query_arrival_date').val();
	if (!selectedDate)
		selectedDate = $("#arrival_date_select").val();
	updatePackagesForDate(createUTC(selectedDate));
	function dateChanged(date) {
		window.lpDateSelected = window.lpDateSelected || 0;

		if (selectedDate != date) {
			updatePackagesForDate(createUTC(date));
			selectedDate = date;
			return true;
		}
		return false;
	}

	var container = "#listing-availability-container";

	//$inquiryDatePicker,
	$listingDatePicker.datepicker({
		language: selectedLanguage,
		format: "yyyy-mm-dd",
		container: container,
		weekStart: 1,
		autoclose: true,
		orientation: "bottom auto",
		beforeShowDay: function(date) {
			var result = true;

			if (availabilities.dates) {
				result = {
					enabled: false,
					classes: ''
				};

				var datestr = dateShortString(createUTC(date));
				if (availabilities.dates[datestr]) {
					var classes = "available";

					if (availabilities.guaranteed && availabilities.guaranteed[datestr]) {
						classes = classes.concat(" guaranteed");
					}

					var pkgInstantDates = window.lpInstantDates && window.lpInstantDates[selectedPackageId];
					if (pkgInstantDates && pkgInstantDates[datestr]) {
						classes = classes.concat(" has-instant-booking");
					}

					result.enabled = true;
					result.classes = classes;
				}
			}
			return result;
		}
	})
	.on('show', function() {
		ctx.hasSelectedArrivalDate = true;
		if (availabilities.dates) {
			$('.public .datepicker:visible').addClass('listing-show');
		}
		$('.public .datepicker:visible').on('mouseover.duration', '.available', function() {
			unhighlightDuration();
			return highlightDuration(this);
		}).on('mouseout.duration', '.available', function() {
			unhighlightDuration();
			return highlightDuration('.public .datepicker:visible .day.active');
		});
		return highlightDuration('.public .datepicker:visible .day.active');
	})
	.on('hide', function() {
		$('.public .datepicker:visible .day.active').off('click.disabled');
		return $('.public .datepicker:visible').off('mouseover.duration mouseout.duration', '.available');
	})
	.on('keypress', function() {
		return !availabilities.dates;
	})
	.on('changeDate', function(date) {
		// set the selected date so we can use that.
		setSelectedDate(date.currentTarget.defaultValue);

		if (!dateChanged(date.format('yyyy-mm-dd'))) {
			var datestr = dateShortString(createUTC(date));
			if (availabilities.guaranteed && availabilities.guaranteed[datestr]) {
				$('#instant_reservation_date_selected').removeClass('hidden');
			} else {
				$('#instant_reservation_date_selected').addClass('hidden');
			}
		}
		if( selectedLanguage != 'en') {
			return $('#beauty_arrival_date, .js--beauty_arrival_date').val(date.format('DD d MM, yyyy'));
		} else {
			return $('#beauty_arrival_date, .js--beauty_arrival_date').val(date.format('DD MM d, yyyy'));
		}
	})
	.on('changeMonth', function(event) {
		return setTimeout(highlightDurationForActive, 1);
	});


	$('#beauty_arrival_date, .js--beauty_arrival_date').on('click', function() {
		return $listingDatePicker.datepicker('show');
	})
	.on('keypress', function() {
		return false;
	});

	$('#beauty_inq_arrival_date').on('click', function() {
		return $listingDatePicker.datepicker('show');
	})
	.on('keypress', function() {
		return false;
	});

	$('.availability-dates label.date_picker').on('click', function() {
		return $listingDatePicker.datepicker('show');
	});

	if ($listingDatePicker.val()) {
		$listingDatePicker.datepicker('setDate', $('#listing_query_arrival_date').val());
	}

	$('.js-calendar-open').click(() => $listingDatePicker.datepicker('show'))


	function setSelectedDate(value) {
		// get form
		const form = document.querySelector('#listing-booking-form');
		form.dataset.selectedDate = value;
	}

	function decompressAvailability(compressed) {
		if (!compressed)
			return null;

		var availability = [];
		var codes = compressed.toString().split(",");
		var date;

		for (var index in codes) {
			var code = codes[index];
			var discountIndex = code.indexOf("#");
			var frags = code.split("-");
			var count = (frags.length > 1) ? parseInt(frags[1]) : 1;
			code = frags[0];

			var type;
			var price;
			var slots;
			var discountedPrice ;
			if (index > 0) {
				date.setDate(date.getDate() + parseInt(code.slice(0, 4)));
				type = parseInt(code.slice(4, 5));
				discountedPrice =  parseInt(code.slice(discountIndex+1));
				if (type == 1) {
					slots = parseInt(code.slice(5, 7));
					price = parseInt(code.slice(7,discountIndex));
				} else {
					price = parseInt(code.slice(5,discountIndex));
				}
			} else {
				date = new Date(0);
				date.setUTCFullYear(parseInt(code.slice(0, 2)) + 2000);
				date.setUTCMonth(parseInt(code.slice(2, 4))-1);
				date.setUTCDate(parseInt(code.slice(4, 6)));
				type = parseInt(code.slice(6, 7));
				discountedPrice =  parseInt(code.slice(discountIndex+1));
				if (type === 1) {
					slots = parseInt(code.slice(7, 9));
					price = parseInt(code.slice(9,discountIndex));
				} else {
					price = parseInt(code.slice(7,discountIndex));
				}
			}

			for (var i = 0; i < count; ++i) {
				var obj = { date: createUTC(date), type: type, price: price, slots: slots  , discountedPrice : discountedPrice };

				availability.push(obj);
				date.setDate(date.getDate() + 1);
			}
		}

		return availability;
	}

	$('.js-dialogs-date-picker').each(function(i, dt) {
		var $dt = $(dt);
		$dt.datepicker({
			language: selectedLanguage,
			format: ($dt.data('date-format') ?  $dt.data('date-format') : "yyyy-mm-dd"),
			weekStart: 1,
			autoclose: true,
			orientation: "bottom auto",
			beforeShowDay: function(date) {
				return true;
			}
		})
			.on('show', function() {
			})
			.on('hide', function() {
			})
			.on('keypress', function() {
				return !availabilities.dates;
			})

			.on('changeDate', function(event) {
				var el = $($dt.data('target'));
				var fmt = $dt.data('target-date-format') ? $dt.data('target-date-format') : 'DD MM d, yyyy';
				return el.is('input') ? el.val(event.format(fmt)) : el.html(event.format(fmt));
			})

			.on('changeMonth', function(event) {});

		$($dt.data('target'))
			.on('click', function() { return $dt.datepicker('show') })
			.on('keypress', function() { return false; });

		$dt.parents('label').on('click', function() {
			return $dt.datepicker('show');
		});

		if ($dt.val())
			$dt.datepicker('setDate', $dt.val());

		return $($dt.data('icon-id')).on('click', function() {
			return $dt.datepicker('show');
		});
	});

	// request to book button in the package
	$('.js-reserve-link').click( function() {
		$(this).parent().parent().find('input').click();
		$('#reservation-query-submit').trigger('click');
	});


	// instant book button in the package
	$('.js-instant-book-link').click( function() {
		$(this).parent().parent().find('input').click();
		$('#instant-booking-query-submit').trigger('click');
	});
}

$( function() { initDatePicker() });
